import { Injectable, signal } from '@angular/core';
import { Breadcrumb } from '../../../@ui/admin/breadcrumbs/breadcrumbs.component';

@Injectable({
    providedIn: 'root'
})
export class AdminService {
    private breadcrumbs = signal<Breadcrumb[]>([]);

    public setBreadcrumbs(breadcrumbs: Breadcrumb[]) {
        this.breadcrumbs.set(breadcrumbs);
    }

    public getBreadcrumbs() {
        return this.breadcrumbs;
    }
}
